import { UpgradeSubscriptionModal } from '@components'

import { Button, Dropdown, useModal } from '@billy/design-system'
import { ReactElement, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../../../../../enums/modalId'
import { TrackingContext } from '../../../../../../../../../../../../enums/trackingContext'
import { useComponentId } from '../../../../../../../../../../../../hooks'
import { InvoiceDiscountsOptions } from './elements/InvoiceDiscountsOptions'

export const InvoiceDiscounts = (): ReactElement => {
  const { t } = useTranslation()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const upgradeModalId = useComponentId(ModalId.UpgradeSubscriptionModal)
  const { open: openUpgradeModal } = useModal(upgradeModalId)

  const handleDropdownOpen = useCallback(() => setIsDropdownOpen(true), [])
  const handleDropdownClose = useCallback(() => setIsDropdownOpen(false), [])

  const handleUpgradeRequired = useCallback(() => {
    handleDropdownClose()
    openUpgradeModal()
  }, [handleDropdownClose, openUpgradeModal])

  return (
    <>
      <Dropdown
        isOpen={isDropdownOpen}
        onClose={handleDropdownClose}
        onOpen={handleDropdownOpen}
        placement="bottom-start"
        size="fitTrigger"
        trigger={
          <Button
            active={isDropdownOpen}
            icon="percent"
            iconRight={isDropdownOpen ? 'chevronUp' : 'chevronDown'}
            size="md"
            variant="text"
          >
            {t('external_invoices.editor.form.field.invoice_lines.discounts')}
          </Button>
        }
      >
        <InvoiceDiscountsOptions onUpgradeRequired={handleUpgradeRequired} />
      </Dropdown>
      <UpgradeSubscriptionModal id={upgradeModalId} trackingContext={TrackingContext.InvoiceDiscount} />
    </>
  )
}
